module.exports = __webpack_public_path__ + "static/media/21ECLAC12.c3d9a89a.jpg";